module.exports = __webpack_public_path__ + "static/Maurice_blue-017955205f5c0b8e85503b719584a0f9.png";